import React from 'react';
import PropTypes from 'prop-types';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

export default class SubstanceAlternativeDetails extends React.PureComponent {
  isMoreNamesAvailable() {
    const detailsPath = 'substance.details';
    // eslint-disable-next-line prefer-template
    const isChemicalNames = getValueByNs(this.props, detailsPath + '.chemicalNames.length', false);
    // eslint-disable-next-line prefer-template
    const isChemicalNameSynonyms = getValueByNs(this.props, detailsPath + '.chemicalNameSynonyms.length', false);
    const isPubchemReferences = getValueByNs(this.props, 'substance.pubchemReferences', false);

    return isPubchemReferences && isChemicalNames && isChemicalNameSynonyms;
  }

  render() {
    const { toggleSuppliers, toggleIdentification, toggleMoreNames, substance } = this.props;
    const { supplierData } = substance;

    return (
      <ul className="substance-details-left">
        <li>
          <a
            data-e2e="substance-identification-link"
            className="rx-btn rx-btn--small rx-btn--basic_link blue additional-names-link identification"
            href="null"
            onClick={(e) => {
              e.preventDefault();
              toggleIdentification();
            }}>
            <span className="rx-btn-text">
              <span>Identification</span>
            </span>
          </a>
        </li>
        {supplierData && (
          <li>
            <a
              data-e2e="substance-supplier-information-link"
              className="rx-btn rx-btn--small rx-btn--basic_link blue additional-names-link supplier-information"
              href="null"
              onClick={(e) => {
                e.preventDefault();
                toggleSuppliers();
              }}>
              <span className="rx-btn-text">
                <span>Supplier Information</span>
              </span>
            </a>
          </li>
        )}
        {this.isMoreNamesAvailable() && (
          <li>
            <a
              data-e2e="substance-more-names-link"
              className="rx-btn rx-btn--small rx-btn--basic_link blue additional-names-link supplier-information"
              href="null"
              onClick={(e) => {
                e.preventDefault();
                toggleMoreNames();
              }}>
              <span className="rx-btn-text">
                <span>More names</span>
              </span>
            </a>
          </li>
        )}
      </ul>
    );
  }
}

SubstanceAlternativeDetails.propTypes = {
  toggleSuppliers: PropTypes.func.isRequired,
  toggleIdentification: PropTypes.func.isRequired,
  substance: PropTypes.object.isRequired,
  toggleMoreNames: PropTypes.func,
};
